import styled from 'styled-components';

interface PropsShow {
  show?: boolean;
}

export const Container = styled.div<PropsShow>`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
`;
